import { createAction } from 'redux-actions';
export const SET_ERROR = 'EXCHANGE/SET_ERROR';
export const CLEAR_ERROR = 'EXCHANGE/CLEAR_ERROR';
export const setError = createAction(SET_ERROR);
export const clearError = createAction(CLEAR_ERROR);
